import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { Location} from '~commonInfra/utils/Location';
import { Messages } from '~src/codegen/Localize';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { HelpService } from '../../services/HelpService';
import { imgPath } from '../../utils/ImgUrl';
import { buttonWrapper, getListWrapper, header, imageContent, textContent, wrapper } from './DMAwarenessStyles';
import { DMAwarenessInExploreActionPlaces, DMAwarenessInExploreActions, sendDMAwarenessTelemetry } from './DMAwarenessTelemetry';
import { sendDisableDMAwarenessRequest, showDisableDataManagementAwarenessToast } from './DmAwarenessUtils';



export type LineagePreviewComponentProps = {
    readonly siteUrls: SpacesSiteUrls;
    readonly datasourceId: string; // need to remove this and refactor it for DQW's
    readonly imageSrc: string;
    readonly helpTextHeading: string;
    readonly informationalListLabel: string; // Refactor and remove this prop
    readonly helpTextList: Array<string>;
};

export function LineagePreview(props: LineagePreviewComponentProps): JSX.Element {
    let helpText: Array<JSX.Element>=[];
     props.helpTextList.forEach(
        (element)=>{ helpText.push(<li>{element}</li>); }
    );


  const onDismiss = () => {
    disableDMAwarenessSetting();
  };
  function disableDMAwarenessSetting() {
    const currentUser = getSessionManagementServiceInstance().sessionUserInfo();
    const siteUrls = props.siteUrls;
    const datasourceLineageUrl = siteUrls.datasourceLineageUrl(props.datasourceId);
    const url = siteUrls.userSettingsUrl(currentUser.username, currentUser.domainName);

    sendDisableDMAwarenessRequest(currentUser.id);
    sendDMAwarenessTelemetry(
      DMAwarenessInExploreActions.HideAction,
      DMAwarenessInExploreActionPlaces.Lineage);
    Location.instance.setUrl(datasourceLineageUrl);
    _.defer(() => {
        showDisableDataManagementAwarenessToast(url);
    });
  }
    const onLearnMore = () => {
      sendDMAwarenessTelemetry(
        DMAwarenessInExploreActions.LearnMoreAction,
        DMAwarenessInExploreActionPlaces.Lineage);
        window.open(HelpService.getHelpUrlByCategory('server-dmaware-lineage-cloud'), '_blank');
    };
    sendDMAwarenessTelemetry(
      DMAwarenessInExploreActions.ViewDMAwarenessFeature,
      DMAwarenessInExploreActionPlaces.Lineage);
    return (
        <div className={wrapper}>
          <div className={imageContent}>
            <img width={600} alt={Messages.lineageInformationContentHeader()} src={imgPath('lineage_preview.gif')}/>
          </div>
          <div className={textContent}>
            <div className={header}>{props.helpTextHeading}</div>
            <div>{Messages.lineageInformationalListLabel()}</div>
            <ul className={getListWrapper()}>
                {helpText}
            </ul>
            <div className={buttonWrapper}>
              <ButtonWidget onClick={onLearnMore} buttonType={ButtonType.Primary}>{Messages.learnMore()}</ButtonWidget>
              <ButtonWidget onClick={onDismiss} buttonType={ButtonType.LowEmphasis}>{Messages.flowSchedulesInformationalNoThanks()}</ButtonWidget>
            </div>
          </div>
        </div>
      );
}

